import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import { alerts, richTextEditor } from 'app/components/global';
import controller from './edit-pandemic-plan-procedure-dialog.controller';
import template from './edit-pandemic-plan-procedure-dialog.html';


class dialogService {
  getOptions($event, { assessmentId, procedure }) {
    return {
      controller,
      controllerAs: 'editPandemicPlanProcedureDialogVM',
      locals: {
        assessmentId,
        procedure
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editPandemicPlanProcedureDialog', [
  alerts,
  richTextEditor,
  bcpDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .service('editPandemicPlanProcedureDialog', dialogService)
  .name;
